import { cva } from 'class-variance-authority';

export const cvaRoot = cva(['QuestionsItemsStyles-cvaRoot', '']);

export const cvaQuestionsItems = cva(['QuestionsItemsStyles-cvaQuestionsItems', 'not-last:mb-3.2']);

export const cvaShowMore = cva(['QuestionsItemsStyles-cvaShowMore', 'not-last:mb-3.2', 'text-center']);

export const cvaShowMoreButton = cva([
  'QuestionsItemsStyles-cvaShowMoreButton',
  'inline-flex items-center justify-center gap-[0.45rem]',
  'min-w-[24.7rem] sm:min-w-[34rem]',
  'py-[1.8rem] sm:py-[2.45rem] pb-[2.2rem] sm:pb-[2.85rem] px-2',
  'text-center text-bodyLSemibold',
  'rounded-[3.2rem] border border-0.1 border-cBlack',
]);

export const cvaShowMoreButtonIcon = cva([
  'QuestionsItemsStyles-cvaShowMoreButtonIcon',
  'w-1.8 h-1.8',
  'relative top-0.2',
  'stroke-cBlack',
]);

export const cvaItem = cva(['QuestionsItemsStyles-cvaItem', '']);

export const cvaItemWrapper = cva(['QuestionsItemsStyles-cvaItemWrapper', '']);

export const cvaItemInner = cva(['QuestionsItemsStyles-cvaItemInner', '']);
